export const deleteIndexedDbDatabase = (dbName) => {
  return new Promise((resolve) => {
    if (typeof window === "undefined") {
      resolve();
      return;
    }
    if (!dbName) {
      resolve();
      return;
    }
    try {
      const request = window.indexedDB.deleteDatabase(dbName);
      request.onsuccess = () => resolve();
      request.onerror = () => resolve();
      request.onblocked = () => resolve();
    } catch (error) {
      console.error(`Failed to delete IndexedDB ${dbName}`, error);
      resolve();
    }
  });
};

export const clearAllBrowserCaches = async () => {
  if (typeof window === "undefined") return;

  const tasks = [];

  if (window.caches && typeof window.caches.keys === "function") {
    tasks.push(
      window.caches
        .keys()
        .then((cacheNames) =>
          Promise.all(
            cacheNames.map((cacheName) =>
              window.caches.delete(cacheName).catch(() => false)
            )
          )
        )
        .catch((error) =>
          console.error("Failed to clear CacheStorage entries", error)
        )
    );
  }

  if (
    window.indexedDB &&
    typeof window.indexedDB.deleteDatabase === "function" &&
    typeof window.indexedDB.databases === "function"
  ) {
    tasks.push(
      window.indexedDB
        .databases()
        .then((dbs) =>
          Promise.all((dbs || []).map((dbInfo) => deleteIndexedDbDatabase(dbInfo?.name)))
        )
        .catch((error) =>
          console.error("Failed to enumerate IndexedDB databases", error)
        )
    );
  }

  if (
    typeof navigator !== "undefined" &&
    navigator.serviceWorker &&
    typeof navigator.serviceWorker.getRegistrations === "function"
  ) {
    tasks.push(
      navigator.serviceWorker
        .getRegistrations()
        .then((registrations) =>
          Promise.all(registrations.map((registration) => registration.unregister()))
        )
        .catch((error) =>
          console.error("Failed to unregister service workers", error)
        )
    );
  }

  if (tasks.length) {
    await Promise.allSettled(tasks);
  }
};

